import script from "./ProfileChooseComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileChooseComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileChooseComponent.vue?vue&type=style&index=0&id=b45068c6&scoped=true&lang=css"

import exportComponent from "../../../web-sequence-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b45068c6"]])

export default __exports__